module.exports = __webpack_public_path__ + "static/media/logo_no.f9a53fa9.svg";